function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, objectSpread2 as _objectSpread2, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import { reaction, observable, action, computed } from 'mobx';
import AnnotationField, { getFieldData } from "./AnnotationField.js";
import { DrawMode } from "../types/index.js";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class2, _temp;

function positionComparator(first, second) {
  var yDiff = first.y - second.y;
  var yDiffMagnitude = Math.abs(yDiff);
  var lineHeight = yDiff < 0 ? first.height : second.height;
  var onSameLine = yDiffMagnitude < lineHeight;
  if (!onSameLine) return yDiff;
  return first.x - second.x;
}

var PdfPageStore = (_class = (_temp = _class2 =
/*#__PURE__*/
function () {
  function PdfPageStore(pdfDocumentStore, pageNumber, fields) {
    var _this2 = this;

    _classCallCheck(this, PdfPageStore);

    this.pageNumber = void 0;
    this.pdfStore = void 0;
    this.pdfDocumentStore = void 0;

    _initializerDefineProperty(this, "fields", _descriptor, this);

    _initializerDefineProperty(this, "pageProxy", _descriptor2, this);

    _initializerDefineProperty(this, "width", _descriptor3, this);

    _initializerDefineProperty(this, "height", _descriptor4, this);

    this.unScale = function (value) {
      return Math.round(value / _this2.pdfDocumentStore.scale);
    };

    this.generateFieldFromPoints = function (drawingFieldStart, currentMouseLocation, drawing) {
      var _this$pdfStore$assign;

      var startX = drawingFieldStart.x,
          startY = drawingFieldStart.y;
      var currentMouseX = currentMouseLocation.x,
          currentMouseY = currentMouseLocation.y;
      var width = Math.abs(startX - currentMouseX);
      var height = Math.abs(startY - currentMouseY);
      var x = Math.min(startX, currentMouseX);
      var y = Math.min(startY, currentMouseY);
      var data = getFieldData(_this2.pdfStore.drawMode);

      if (_this2.pdfStore.drawMode === DrawMode.Checkbox) {
        var scaledMinWidth = PdfPageStore.MIN_FIELD_WIDTH * _this2.pdfDocumentStore.scale;

        if (width < Math.floor(scaledMinWidth) && !drawing) {
          width = scaledMinWidth;
          x -= scaledMinWidth / 2;
          y -= scaledMinWidth / 2;
        }

        height = width;

        if (startY > currentMouseY) {
          y = startY - width;
        }
      }

      return new AnnotationField({
        x: _this2.unScale(x),
        y: _this2.unScale(y),
        width: _this2.unScale(width),
        height: _this2.unScale(height),
        page: _this2.pageNumber,
        data: _objectSpread2(_objectSpread2({}, data), {}, {
          assignedTo: (_this$pdfStore$assign = _this2.pdfStore.assignmentStore.defaultOption) === null || _this$pdfStore$assign === void 0 ? void 0 : _this$pdfStore$assign.assignmentKey
        })
      });
    };

    _initializerDefineProperty(this, "addOrReplaceDrawingField", _descriptor5, this);

    _initializerDefineProperty(this, "pasteField", _descriptor6, this);

    _initializerDefineProperty(this, "addField", _descriptor7, this);

    _initializerDefineProperty(this, "deleteField", _descriptor8, this);

    _initializerDefineProperty(this, "setPageProxy", _descriptor9, this);

    _initializerDefineProperty(this, "moveFieldToFront", _descriptor10, this);

    _initializerDefineProperty(this, "setDimensions", _descriptor11, this);

    _initializerDefineProperty(this, "updateDraggingFieldLocation", _descriptor12, this);

    _initializerDefineProperty(this, "updateResizingFieldDimensions", _descriptor13, this);

    this.pdfDocumentStore = pdfDocumentStore;
    this.pdfStore = pdfDocumentStore.pdfStore;
    this.pageNumber = pageNumber;
    this.fields = fields.sort(positionComparator);
    reaction(function () {
      return _this2.fields.map(function (field) {
        return field.data;
      });
    }, function () {
      _this2.pdfStore.setIsDataDirty(true);
    });
  }

  _createClass(PdfPageStore, [{
    key: "contextMenu",
    get: function get() {
      var menu = this.pdfStore.contextMenu;
      return (menu === null || menu === void 0 ? void 0 : menu.page) === this.pageNumber ? menu : undefined;
    }
  }]);

  return PdfPageStore;
}(), _class2.MIN_FIELD_WIDTH = 10, _class2.MIN_FIELD_HEIGHT = 10, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "fields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pageProxy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "width", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "height", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addOrReplaceDrawingField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;

    return function (drawingFieldStart, currentMouseLocation) {
      var drawing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (_this.pdfStore.drawingField) {
        _this.deleteField(_this.pdfStore.drawingField);

        _this.pdfStore.setDrawingField();
      }

      var newField = _this.generateFieldFromPoints(drawingFieldStart, currentMouseLocation, drawing);

      if (newField.height < PdfPageStore.MIN_FIELD_HEIGHT || newField.width < PdfPageStore.MIN_FIELD_WIDTH) {
        return;
      }

      _this.addField(newField);

      if (drawing) {
        _this.pdfStore.setDrawingField(newField);
      } else {
        _this.pdfStore.setDrawingField();

        _this.pdfStore.setSelectedField(newField);
      }
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pasteField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (currentMouseLocation) {
      var copiedField = _this3.pdfStore.copiedField;
      if (!copiedField) return;
      var newField = new AnnotationField(_objectSpread2(_objectSpread2({}, copiedField), {}, {
        id: undefined,
        data: _objectSpread2(_objectSpread2({}, copiedField.data), {}, {
          id: undefined
        }),
        x: _this3.unScale(currentMouseLocation.x),
        y: _this3.unScale(currentMouseLocation.y),
        page: _this3.pageNumber
      }));

      _this3.addField(newField);

      _this3.pdfStore.setSelectedField(newField);

      _this3.pdfStore.setContextMenu();
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "addField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (field) {
      _this4.fields.push(field);
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deleteField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (field) {
      _this5.fields.remove(field);
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setPageProxy", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (pageProxy) {
      _this6.pageProxy = pageProxy;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "moveFieldToFront", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (field) {
      _this7.deleteField(field);

      _this7.addField(field);
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "contextMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contextMenu"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setDimensions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (width, height) {
      _this8.width = _this8.unScale(width);
      _this8.height = _this8.unScale(height);
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "updateDraggingFieldLocation", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (originalFieldLocation, mouseStart, currentMouse) {
      var field = _this9.pdfStore.draggingField; // Determine updated field location based on original field position and
      // mouse movement.

      var updatedX = originalFieldLocation.x + _this9.unScale(currentMouse.x - mouseStart.x);

      var updatedY = originalFieldLocation.y + _this9.unScale(currentMouse.y - mouseStart.y); // Ensure that the field is not draggable outside of the pdf page.


      var minX = 0;
      var maxX = _this9.width - field.width;
      var minY = 0;
      var maxY = _this9.height - field.height;
      field.updateAttributes({
        x: Math.min(maxX, Math.max(updatedX, minX)),
        y: Math.min(maxY, Math.max(updatedY, minY))
      });
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "updateResizingFieldDimensions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;

    return function (originalFieldLocAndDims, mouseStart, currentMouse) {
      var field = _this10.pdfStore.resizingField; // Determine updated field dimensions based on original dimensions and
      // mouse movement.

      var updatedWidth = originalFieldLocAndDims.width + _this10.unScale(currentMouse.x - mouseStart.x);

      var updatedHeight = originalFieldLocAndDims.height + _this10.unScale(currentMouse.y - mouseStart.y); // Ensure that the field is not resizable outside of the pdf page.


      var minWidth = PdfPageStore.MIN_FIELD_WIDTH;
      var maxWidth = _this10.width - originalFieldLocAndDims.x;
      var minHeight = PdfPageStore.MIN_FIELD_HEIGHT;
      var maxHeight = _this10.height - originalFieldLocAndDims.y;
      field.updateAttributes({
        width: Math.min(maxWidth, Math.max(updatedWidth, minWidth)),
        height: Math.min(maxHeight, Math.max(updatedHeight, minHeight))
      });
    };
  }
})), _class);
export default PdfPageStore;
export { positionComparator };